
// SESSION TYPES
export const GET_SESSION_TYPES = "/session-types";
export const ADD_NEW_SESSION_TYPE = "/session-types";
export const UPDATE_SESSION_TYPE = "/session-types";
export const DELETE_SESSION_TYPE = "/session-types";


